import React, { useState, useEffect } from "react";
import { ParticipantTabNavs } from "@/shared/components/tabNavs";
import Sidebar from "@/containers/Layout/sidebar";
import AccountForm from "@/shared/components/account/AccountForm";
import ClearPageLayout from "@/containers/Participant/components/ClearPageLayout";
import { Col, Row, Container } from "reactstrap";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import TextNotificationsModal from "@/shared/components/account/TextNotificationsModal";
import { getUser } from "@/services/program/getUser";
import { hasSmsablePhoneNumber } from "@/shared/helpers";

const CLASSIC_IMG_BACK = `${process.env.PUBLIC_URL}/theme/classic/img/pages/my-points.jpg`;

const Account = ({ template, organization, program, auth }) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  let [user, setUser] = useState(null);

  useEffect(() => {
    if (auth && organization && program) {
      getUser(organization.id, program.id, auth.id).then((payload) => {
        setUser(payload);
      });
    }
  }, [organization, program, auth]);

  // useEffect(() => {
  //   user && setOpen( !hasSmsablePhoneNumber(user) ? true : false )
  // }, [user])

  useEffect(() => {
    if (user) {
      const shouldOpen =
        !user.phone_notifications && !hasSmsablePhoneNumber(user);

      setOpen(shouldOpen);
    }
  }, [user]);

  const toggle = () => {
    setOpen((prevState) => !prevState);
  };

  if (!auth || !program || !organization || !user) return t("loading");

  // Plain elements, not components declared here: a component defined inside render
  // is a new type every render, so opening the notifications modal remounted the form
  // and threw away any unsaved edits
  const accountClear = (
    <div className="account-page">
      <div className="account-page__header">
        <Container>
          <div className="account-page__header-inner">
            <div>
              <h1 className="account-page__title">{t("my_account")}</h1>
              <p className="account-page__desc">{t("my_account_desc")}</p>
            </div>
          </div>
        </Container>
      </div>

      <Container className="account-page__body">
        <ClearPageLayout>
          <div className="account-page__panel">
            <AccountForm {...{ toggle, user }} />
          </div>
        </ClearPageLayout>
      </Container>

      <TextNotificationsModal {...{ isOpen, toggle, user }} />
    </div>
  );

  const accountClassic = (
    <>
      <div className="mainboard">
        <img src={CLASSIC_IMG_BACK} alt="account" />
      </div>

      <Container>
        <ParticipantTabNavs />
      </Container>

      <Container>
        <Row>
          <Col md={9}>
            <div className="dashboard">
              <AccountForm {...{ toggle, user }} />
            </div>
          </Col>
          <Col md={3}>
            <Sidebar />
          </Col>
        </Row>
        <TextNotificationsModal {...{ isOpen, toggle, user }} />
      </Container>
    </>
  );

  return (
    (template?.name === "clear" && accountClear) ||
    (template?.name === "classic" && accountClassic)
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  program: state.program,
  organization: state.organization,
  template: state.template,
});
export default connect(mapStateToProps)(Account);
